Wee.fn.make('checkout', {
	init: function() {
		var priv = this.$private,
			orgTypes = Wee.fn.dropdown(),
			states = Wee.fn.dropdown();

		orgTypes.init({
			selector: 'ref:orgTypes',
			appPrefix: 'orgTypes',
			rootModifier: 'cart-form__org-types'
		});

		states.init({
			selector: 'ref:states',
			appPrefix: 'states',
			rootModifier: 'cart-form__state'
		});

		priv.addAddress();
		priv.managePrice();
		priv.bind();
	}
}, {
	bind: function() {
		var scope = this;

		$('ref:modifyCount').on('click', function(e, el) {
			var $el = $(el),
				$input = $el.parent().find('ref:productQty'),
				$form = $('.js-update-cart-form');

			if ($el.data('value') == 'increment') {
				$input.val(parseInt($input.val()) + 1);
			} else {
				$input.val(parseInt($input.val()) - 1);
			}

			$.history.go({
				path: $form.attr('action').match(/[https|http]:\/\/.*\/(.*)/)[1],
				request: {
					method: 'post',
					data: $form.serialize(),
					type: 'form',
					headers: {
						'X-Requested-With': false,
						'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
					},
					send: function() {
						$('ref:cart').disable();
					},
					success: function() {
						$.setRef();

						$('ref:cart').enable();
					}
				}
			});
		});

		$('ref:removeItem').on('click', function(e, el) {
			$.fetch.request({
				url: '/ajax/delete-from-cart/' + $(el).data('rowId'),
				method: 'post',
				type: 'form',
				json: true,
				headers: {
					'X-Requested-With': false
				},
				success: function() {
					$.history.go({
						path: $.routes.uri().full
					});
				}
			});
		});

		$('.cart-form').on('submit', function(e) {
			scope.removeFormErrors();

			if (scope.formIsComplete()) {
				return;
			}

			e.preventDefault();
		});
	},

	formIsComplete: function() {
		var scope = this,
			textFields = scope.textFieldsAreFilled(),
			emailFormats = scope.emailFormatsAreCorrect(),
			dropdownFields = scope.dropdownsAreSelected();

		return textFields && emailFormats && dropdownFields;
	},

	textFieldsAreFilled: function() {
		var inputs = $('.cart-form').find('input[type=text]').not('[data-exclude]'),
			output = true,
			scope = this;

		inputs.each(function(el) {
			if (el.value === '') {
				scope.addFormError(el, 'blank');

				output = false;
			}
		});

		return output;
	},

	emailFormatsAreCorrect: function() {
		var regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*@[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]*\.[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{2,}/,
			$inputs = $('ref:emailFormat'),
			output = true,
			scope = this;

		$inputs.each(function(el) {
			if (! el.value) {
				return;
			}

			if (! regex.test(el.value)) {
				output = false;

				scope.addFormError(el, 'emailFormat');
			}
		});

		return output;
	},

	dropdownsAreSelected: function() {
		var $inputs = $('ref:dropdownField'),
			output = true,
			scope = this;

		$inputs.each(function(el) {
			if (! el.value) {
				// The visual dropdown is being passed here, instead of the <select> element
				scope.addFormError($(el).next('.dropdown'), 'dropdownNotSelected');

				output = false;
			}
		});

		return output;
	},

	addFormError: function(el, type) {
		var responses = {
			blank: 'This field can\'t be blank.',
			emailFormat: 'Your email doesn\'t appear to be formatted properly.',
			dropdownNotSelected: 'Please select an option.'
		};

		$(el).after('<div class="form-error" data-ref="formError">' + responses[type] + '</div>');

		$.setRef();
	},

	removeFormErrors: function() {
		$('ref:formError').remove();
	},

	managePrice: function() {
		var $prices = $('ref:price');

		$prices.each(function(el) {
			var $el = $(el);

			if ($el.html() == '0') {
				$el.parent().html('Call for pricing');
			}
		});
	},

	addAddress: function() {
		$('ref:addAddress').on('click', function() {
			var $input = $('ref:addressInput').last();

			$input.after($input.clone().val(''));
		});
	}
});